import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { InfoBox } from '../common'
import screenImg from '../../../../../resources/img/icons/screen.png'

const PopularSize = ({ isEmpty, loading, onClickHeader, size, t }) => (
    <InfoBox title={t('Popular Size')} value={size ? `${size}″` : 'n/a'} img={screenImg} isEmpty={isEmpty} loading={loading} onClickHeader={onClickHeader} />
)

PopularSize.propTypes = {
    isEmpty: PropTypes.bool,
    loading: PropTypes.number,
    onClickHeader: PropTypes.func,
    size: PropTypes.string,
    t: PropTypes.func.isRequired,
}

PopularSize.defaultProps = {
    isEmpty: true,
    loading: null,
    onClickHeader: () => null,
    size: null,
}

export default withTranslation()(PopularSize)
